import { styled, Grid, Card, lighten } from "@mui/material";
import { EmployeeSurveyStatuses } from "src/utils/constants/constants";
import Ellipse from "../../../assets/images/Ellipse.svg";

export const CardWrapper = styled(Grid)({});

export const StyledCard = styled(Card)({
  display: "flex",
  gap: "20px",
  borderRadius: "5px",
});

export const DateContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  gap: "5px",
  alignItems: "center",
  color: theme.palette.secondary.light,
  "& >.MuiTypography-root": {
    fontSize: "28px",
  },
  "& >.MuiGrid-root": {
    display: "flex",
    flexDirection: "column",
    "& .MuiTypography-root": {
      lineHeight: "13px",
    },
  },
}));

export const AddedOnBlock = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px 0px 20px 20px",
  width: "120px",
});

export const TitleAndExpiryDateBlock = styled(Grid)({
  flex: 2,
  padding: "20px 0px",
});

export const ExpirySection = styled(Grid)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
});

export const DaysLeftBlock = styled(Grid)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  flex: 2,
  padding: "20px 0px",
});

export const StatsBlock = styled(Grid)({
  padding: "20px 0px",
});

export const StatsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: `url(${Ellipse})`,
  maxWidth: "100px",
  height: "100px",
  width: "100px",
  textAlign: "center",
});

export const StatusBlock = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "statusId",
})<{ statusId: string }>(
  {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "140px",
    width: "140px",
  },
  ({ statusId, theme }) => ({
    backgroundColor:
      statusId === EmployeeSurveyStatuses.Pending.id
        ? lighten(theme.palette.error.light, 0.8)
        : lighten(theme.palette.primary.light, 0.8),
    color: statusId === EmployeeSurveyStatuses.Pending.id ? theme.palette.error.main : theme.palette.primary.main,
  })
);
